export enum OAuth2GooglePrompt {
    None = 'none',
    Consent = 'consent',
    SelectAccount = 'select_account',
}
